<template>
  <el-form-item class="input-range" :label="label">
    <el-input
      v-model="dateModel.min"
      :placeholder="placeholderMin"
      @input="dateModel.min = dateModel.min.replace(/[^\d\-]/g,'')"
      @blur="handleBlurMin"
      clearable
      ></el-input>
    <div class="input-range-divider"></div>
    <el-input
      v-model="dateModel.max"
      :placeholder="placeholderMax"
      @input="dateModel.max = dateModel.max.replace(/[^\d\-]/g,'')"
      @blur="handleBlurMax"
      clearable
      ></el-input>
  </el-form-item>
</template>

<script>
// import { computed, inject } from 'vue';
import { inject } from 'vue';

export default {
  kind: 'yq-数字区间',
  props: {
    // 初始值
    value: {
      type: [Object],
      default() {
        return {
          min: '',
          max: '',
        };
      },
    },
    label: {
      type: String,
      default: '剩余数量：',
    },
    placeholderMin: {
      type: String,
      default: '最小数量',
    },
    placeholderMax: {
      type: String,
      default: '最大数量',
    },
  },
  setup(props) {
    const message = inject('$message');
    const useQuery = inject('useQuery');
    const dateModel = useQuery('inputRange', props.value);

    return {
      // valRange,
      dateModel,
      handleBlurMax() {
        if (!/^-?\d+$/g.test(dateModel.value.max)) {
          dateModel.value.max = '';
        }
        if (dateModel.value.min.length > 0 && dateModel.value.max.length > 0 && Number(dateModel.value.max) < Number(dateModel.value.min)) {
          message.warning(`${props.placeholderMin}不能大于${props.placeholderMax}`);
        }
      },
      handleBlurMin() {
        if (!/^-?\d+$/g.test(dateModel.value.min)) {
          dateModel.value.min = '';
        }
        if (dateModel.value.min.length > 0 && dateModel.value.max.length > 0 && Number(dateModel.value.max) < Number(dateModel.value.min)) {
          message.warning(`${props.placeholderMin}不能大于${props.placeholderMax}`);
        }
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.input-range {
  .input-range-divider {
    display: inline-block;
    width: 7px;
    height: 1px;
    background: #c0c4cc;
    margin: 0 7px 4px 7px;
  }
  .el-input {
    width: 100px !important;
  }
}
</style>
